import { render, staticRenderFns } from "./invoice-batch-details-modal.vue?vue&type=template&id=d1622b80&"
import script from "./invoice-batch-details-modal.vue?vue&type=script&lang=js&"
export * from "./invoice-batch-details-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports